// src/apiService.js

import axiosClient from './axiosClient'; // Import the Axios client

// Function to fetch vehicles
const getVehicles = async () => {
    try {
        const response = await axiosClient.get('/vehicles'); // API call
        return response.data; // Return the data from the response
    } catch (error) {
        console.error('Error fetching vehicles:', error);
        throw error; // Rethrow the error for further handling
    }
};

const getVehicleDetail = async (id) => {
    try {
        const response = await axiosClient.get(`/vehicles/${id}`); // API call
        return response.data; // Return the data from the response
    } catch (error) {
        console.error('Error fetching vehicles:', error);
        throw error; // Rethrow the error for further handling
    }
};

const createVehicle = async (body) => {
    try {

        const response = await axiosClient.post('/vehicles', {
            make: body.make,
            model: body.model,
            color: body.color,
                "registrationNo": body.registrationNo,
                "vehicleTypeID": body.vehicleType
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data; // Return API response
    } catch (error) {
        console.error('Error creating vehicle:', error);
        throw error; // Rethrow error for handling in the component
    }
};

// DELETE vehicle by ID
const deleteVehicle = async (id) => {
    try {
        const response = await axiosClient.delete(`/vehicles/${id}`);
        return response.data; // Return the response data
    } catch (error) {
        console.error('Error deleting vehicle:', error);
        throw error; // Rethrow error for handling in the component
    }
};

// PATCH vehicle by ID
const updateVehicle = async (id, body) => {
    try {
        const response = await axiosClient.patch(`/vehicles/${id}`, {
            make: body.make,
            model: body.model,
            color: body.color,
            registrationNo: body.registrationNo,
            vehicleTypeID: body.vehicleTypeId
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data; // Return the response data
    } catch (error) {
        console.error('Error updating vehicle:', error);
        throw error; // Rethrow error for handling in the component
    }
};

const assignDriverToVehicle = async (body) => {
    try {
        const response = await axiosClient.patch(`/vehicles/assign-driver`, {
            vehicleId: body.vehicleId,
            driverId: body.driverId
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data; // Return the response data
    } catch (error) {
        console.error('Error updating vehicle:', error);
        throw error; // Rethrow error for handling in the component
    }
};

const assignDriverToVehicleCheck = async (body) => {
    try {
        const response = await axiosClient.patch(`/vehicles/assign-driver-check`, {
            vehicleId: body.vehicleId,
            driverId: body.driverId
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data; // Return the response data
    } catch (error) {
        console.error('Error updating vehicle:', error);
        throw error; // Rethrow error for handling in the component
    }
};

// Export the function
export { getVehicles, deleteVehicle, createVehicle, updateVehicle, getVehicleDetail, assignDriverToVehicle, assignDriverToVehicleCheck };
